import React from 'react';
import { sweetalert } from '../../App';
import { isBlank, isOnlyWhitespace } from '../../util/ValidationUtil';
import { buildRow } from '../../util/FormatUtil';

interface KitInventoryCreationModalState {
  total: string;
}
interface KitInventoryCreationModalProps {
  onSubmit?: (filter) => void;
}
export class KitInventoryCreationModal extends React.Component<
  KitInventoryCreationModalProps,
  KitInventoryCreationModalState
> {
  public static ID = 'kitinventorycreation';
  constructor(props) {
    super(props);
    this.state = {
      total: null,
    } as KitInventoryCreationModalState;
  }

  componentDidMount() {
    const modalEl = document.getElementById(KitInventoryCreationModal.ID);
    if (modalEl) {
      $(modalEl).on('hidden.bs.modal', () => {
        this.setState({ total: null });
      });
    }
  }

  render() {
    return (
      <div
        className="modal fade form_modal"
        id={KitInventoryCreationModal.ID}
        tabIndex={-1}
        role="dialog"
        aria-labelledby="result_modal_label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-xl" role="document">
          <div className="modal-content">
            <div className="container-fluid">
              <div className="modal-header">
                <h5 className="modal-title" id="result_modal_label">
                  Kit Creation
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {buildRow("How Many?",
                  <input
                    className="form-control"
                    id="Total"
                    type="number"
                    min={1}
                    max={1000}
                    autoComplete="off"
                    name="Total"
                    aria-label="Total"
                    onChange={(e) => {
                      this.setState({ total: e.target.value });
                    }}
                    value={this.state.total || ''}
                  />
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  const totalNum = parseInt(this.state.total, 10);
                  if (isBlank(this.state.total) || isOnlyWhitespace(this.state.total) || isNaN(totalNum) || totalNum < 1) {
                    return sweetalert.fire("", "Total must be an integer greater than 0", "error");
                  }
                  this.props.onSubmit({ Total: totalNum });
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}